import PropTypes from 'prop-types';
import React from 'react';
import CometaSelect from './CometaSelect';

function StateDropdown(props) {
  var id = props.id,
      isClearable = props.isClearable,
      placeholder = props.placeholder,
      onChange = props.onChange,
      country = props.country,
      classNamePrefix = props.classNamePrefix;
  return React.createElement(CometaSelect, {
    id: id,
    listName: 'state',
    placeholder: placeholder,
    country: country,
    isClearable: isClearable,
    handleChange: onChange,
    classNamePrefix: classNamePrefix
  });
}

StateDropdown.propTypes = {
  isClearable: PropTypes.bool,
  name: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  onFocus: PropTypes.func,
  country: PropTypes.string
};
StateDropdown.defaultProps = {
  isClearable: false,
  placeholder: 'State',
  classNamePrefix: 'SearchableDropdown'
};
export default StateDropdown;